import { isMobile } from '../helpers/isMobile';

export const oddsInfoEnumsByGame = {
  225: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -35, oddContainerY: 25, oddsContainerX: 330, oddsContainerY: 585 },
      { id: 1, oddX: -35, oddContainerY: 25, oddsContainerX: 578, oddsContainerY: 585 },
      { id: 2, oddX: -35, oddContainerY: 25, oddsContainerX: 819, oddsContainerY: 585 },
      { id: 3, oddX: -35, oddContainerY: 25, oddsContainerX: 1058, oddsContainerY: 585 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: -35, oddContainerY: 25, oddsContainerX: 527, oddsContainerY: 230 },
      { id: 7, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 230 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 770 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 770 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 1032 },
      { id: 3, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 1032 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: 12, oddContainerY: 15, oddsContainerX: 330, oddsContainerY: 158 },
      { id: 7, oddX: 12, oddContainerY: 15, oddsContainerX: 325, oddsContainerY: 433 },
    ],
  },
  226: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -35, oddContainerY: 25, oddsContainerX: 330, oddsContainerY: 585 },
      { id: 1, oddX: -35, oddContainerY: 25, oddsContainerX: 578, oddsContainerY: 585 },
      { id: 2, oddX: -35, oddContainerY: 25, oddsContainerX: 819, oddsContainerY: 585 },
      { id: 3, oddX: -35, oddContainerY: 25, oddsContainerX: 1058, oddsContainerY: 585 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: -35, oddContainerY: 25, oddsContainerX: 527, oddsContainerY: 230 },
      { id: 7, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 230 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 770 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 770 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 1032 },
      { id: 3, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 1032 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: 12, oddContainerY: 15, oddsContainerX: 330, oddsContainerY: 158 },
      { id: 7, oddX: 12, oddContainerY: 15, oddsContainerX: 325, oddsContainerY: 433 },
    ],
  },
  227: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -35, oddContainerY: 25, oddsContainerX: 330, oddsContainerY: 585 },
      { id: 1, oddX: -35, oddContainerY: 25, oddsContainerX: 578, oddsContainerY: 585 },
      { id: 2, oddX: -35, oddContainerY: 25, oddsContainerX: 819, oddsContainerY: 585 },
      { id: 3, oddX: -35, oddContainerY: 25, oddsContainerX: 1058, oddsContainerY: 585 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: -35, oddContainerY: 25, oddsContainerX: 527, oddsContainerY: 230 },
      { id: 7, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 230 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 770 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 770 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 1032 },
      { id: 3, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 1032 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: 12, oddContainerY: 15, oddsContainerX: 330, oddsContainerY: 158 },
      { id: 7, oddX: 12, oddContainerY: 15, oddsContainerX: 325, oddsContainerY: 433 },
    ],
  },
  329: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -35, oddContainerY: 25, oddsContainerX: 330, oddsContainerY: 585 },
      { id: 1, oddX: -35, oddContainerY: 25, oddsContainerX: 578, oddsContainerY: 585 },
      { id: 2, oddX: -35, oddContainerY: 25, oddsContainerX: 819, oddsContainerY: 585 },
      { id: 3, oddX: -35, oddContainerY: 25, oddsContainerX: 1058, oddsContainerY: 585 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: -35, oddContainerY: 25, oddsContainerX: 527, oddsContainerY: 230 },
      { id: 7, oddX: -35, oddContainerY: 25, oddsContainerX: 1005, oddsContainerY: 230 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 770 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 770 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 120, oddsContainerY: 1032 },
      { id: 3, oddX: 12, oddContainerY: 15, oddsContainerX: 380, oddsContainerY: 1032 },
      { id: 4 },
      { id: 5 },
      { id: 6, oddX: 12, oddContainerY: 15, oddsContainerX: 330, oddsContainerY: 158 },
      { id: 7, oddX: 12, oddContainerY: 15, oddsContainerX: 325, oddsContainerY: 433 },
    ],
  },
};

export const payTableOddsByGameId = {
  225: [
    [20.0, 4.0, 1.0],
    [10.0,
      2.0,
      1.0
    ],
    [
      10.0,
      2.0,
      1.0
    ],
    [
      5.0,
      1.0,
      0.5
    ],
    [
      5.0,
      1.0,
      0.5
    ],
    [
      5.0,
      1.0,
      0.5
    ],
    [
      50.0,
      20.0,
      2.0
    ],
    [
      500.0,
      20.0,
      5.0
    ]
  ],
  226: [
    [10.0, 2.0, 0.5],
    [
      5.0,
      1.0,
      0.5
    ],
    [
      5.0,
      1.0,
      0.5
    ],
    [
      2.5,
      0.5,
      0.25
    ],
    [
      2.5,
      0.5,
      0.25
    ],
    [
      2.5,
      0.5,
      0.25
    ],
    [
      25.0,
      10.0,
      1.0
    ],
    [
      500.0,
      20.0,
      5.0
    ]
  ],
  227:  [
    [
      4.0,
      0.8,
      0.2
    ],
    [
      2.0,
      0.4,
      0.2
    ],
    [
      2.0,
      0.4,
      0.2
    ],
    [
      1.0,
      0.2,
      0.1
    ],
    [
      1.0,
      0.2,
      0.1
    ],
    [
      1.0,
      0.2,
      0.1
    ],
    [
      10.0,
      4.0,
      0.4
    ],
    [
      500.0,
      20.0,
      5.0
    ]
  ],
  329: [
    [10.0, 2.0, 0.5],
    [
      5.0,
      1.0,
      0.5
    ],
    [
      5.0,
      1.0,
      0.5
    ],
    [
      2.5,
      0.5,
      0.25
    ],
    [
      2.5,
      0.5,
      0.25
    ],
    [
      2.5,
      0.5,
      0.25
    ],
    [
      25.0,
      10.0,
      1.0
    ],
    [
      500.0,
      20.0,
      5.0
    ]
  ],
};

export const gameRulesKeysByGameId = {
  225: [
    { key: 'ABOUT_THE_GAME', type: 'title' },
    { key: 'ABOUT_THE_GAME_P1', type: 'text' },
    { key: 'GENERAL_INFORMATION', type: 'title' },
    { key: 'QUICK_INFO_MATRIX_SIZE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_PAY_LINE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_RTP', type: 'text', isCircle: true, hasLicenseCheck: true },
    { key: 'RTP_GLI', type: 'text', isCircle: true, hasLicenseCheck: false },
    { key: 'QUICK_INFO_VOLATILITY', type: 'text', isCircle: true },
    {
      key: 'QUICK_INFO_MIN_BET',
      type: 'text',
      valueKey: 'minBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_BET',
      type: 'text',
      valueKey: 'maxBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_ODD',
      type: 'text',
      valueKey: 'maxOdd',
      isCircle: true,
      hasLicenseCheck: true,
    },
    { key: 'GAME_INFO_HOW_TO_PLAY', type: 'title' },
    { key: 'HOW_TO_PLAY_P1', type: 'text' },
    { key: 'HOW_TO_PLAY_P2', type: 'text' },
    { key: 'GAME_RULES_GAME_FEATURES', type: 'title' },
    { key: 'AUTO_PLAY', type: 'title', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P1', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P2', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P3', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P4', type: 'text', hasAutoCheck: false },
    { key: 'TURBO_MODE', type: 'title' },
    { key: 'TURBO_MODE_P1', type: 'text' },
    { key: 'CONNECTIVITY_AND_MALFUNCTION', type: 'title' },
    { key: 'MALFUNCTION', type: 'text' },
    { key: 'GAMBLE_FEATURE_TITLE', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_TEXT', type: 'text', hasGambleCheck: false },
    { key: 'GAMBLE_VALIDATIONS', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_VALIDATIONS_TEXT', type: 'text', hasGambleCheck: false },
  ],
  226:[
    { key: 'ABOUT_THE_GAME', type: 'title' },
    { key: 'ABOUT_THE_GAME_P1', type: 'text' },
    { key: 'GENERAL_INFORMATION', type: 'title' },
    { key: 'QUICK_INFO_MATRIX_SIZE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_PAY_LINE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_RTP', type: 'text', isCircle: true, hasLicenseCheck: true },
    { key: 'RTP_GLI', type: 'text', isCircle: true, hasLicenseCheck: false },
    { key: 'QUICK_INFO_VOLATILITY', type: 'text', isCircle: true },
    {
      key: 'QUICK_INFO_MIN_BET',
      type: 'text',
      valueKey: 'minBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_BET',
      type: 'text',
      valueKey: 'maxBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_ODD',
      type: 'text',
      valueKey: 'maxOdd',
      isCircle: true,
      hasLicenseCheck: true,
    },
    { key: 'GAME_INFO_HOW_TO_PLAY', type: 'title' },
    { key: 'HOW_TO_PLAY_P1', type: 'text' },
    { key: 'HOW_TO_PLAY_P2', type: 'text' },
    { key: 'GAME_RULES_GAME_FEATURES', type: 'title' },
    { key: 'AUTO_PLAY', type: 'title', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P1', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P2', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P3', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P4', type: 'text', hasAutoCheck: false },
    { key: 'TURBO_MODE', type: 'title' },
    { key: 'TURBO_MODE_P1', type: 'text' },
    { key: 'CONNECTIVITY_AND_MALFUNCTION', type: 'title' },
    { key: 'MALFUNCTION', type: 'text' },
    { key: 'GAMBLE_FEATURE_TITLE', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_TEXT', type: 'text', hasGambleCheck: false },
    { key: 'GAMBLE_VALIDATIONS', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_VALIDATIONS_TEXT', type: 'text', hasGambleCheck: false },
  ],
  227: [
    { key: 'ABOUT_THE_GAME', type: 'title' },
    { key: 'ABOUT_THE_GAME_P1', type: 'text' },
    { key: 'GENERAL_INFORMATION', type: 'title' },
    { key: 'QUICK_INFO_MATRIX_SIZE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_PAY_LINE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_RTP', type: 'text', isCircle: true, hasLicenseCheck: true },
    { key: 'RTP_GLI', type: 'text', isCircle: true, hasLicenseCheck: false },
    { key: 'QUICK_INFO_VOLATILITY', type: 'text', isCircle: true },
    {
      key: 'QUICK_INFO_MIN_BET',
      type: 'text',
      valueKey: 'minBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_BET',
      type: 'text',
      valueKey: 'maxBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_ODD',
      type: 'text',
      valueKey: 'maxOdd',
      isCircle: true,
      hasLicenseCheck: true,
    },
    { key: 'GAME_INFO_HOW_TO_PLAY', type: 'title' },
    { key: 'HOW_TO_PLAY_P1', type: 'text' },
    { key: 'HOW_TO_PLAY_P2', type: 'text' },
    { key: 'GAME_RULES_GAME_FEATURES', type: 'title' },
    { key: 'AUTO_PLAY', type: 'title', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P1', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P2', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P3', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P4', type: 'text', hasAutoCheck: false },
    { key: 'TURBO_MODE', type: 'title' },
    { key: 'TURBO_MODE_P1', type: 'text' },
    { key: 'CONNECTIVITY_AND_MALFUNCTION', type: 'title' },
    { key: 'MALFUNCTION', type: 'text' },
    { key: 'GAMBLE_FEATURE_TITLE', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_TEXT', type: 'text', hasGambleCheck: false },
    { key: 'GAMBLE_VALIDATIONS', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_VALIDATIONS_TEXT', type: 'text', hasGambleCheck: false },
  ],
  329: [
    { key: 'ABOUT_THE_GAME', type: 'title' },
    { key: 'ABOUT_THE_GAME_P1', type: 'text' },
    { key: 'GENERAL_INFORMATION', type: 'title' },
    { key: 'QUICK_INFO_MATRIX_SIZE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_PAY_LINE', type: 'text', isCircle: true },
    { key: 'QUICK_INFO_RTP', type: 'text', isCircle: true, hasLicenseCheck: true },
    { key: 'RTP_GLI', type: 'text', isCircle: true, hasLicenseCheck: false },
    { key: 'QUICK_INFO_VOLATILITY', type: 'text', isCircle: true },
    {
      key: 'QUICK_INFO_MIN_BET',
      type: 'text',
      valueKey: 'minBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_BET',
      type: 'text',
      valueKey: 'maxBet',
      isCircle: true,
      isCurrency: true,
      isLicense: true,
    },
    {
      key: 'QUICK_INFO_MAX_ODD',
      type: 'text',
      valueKey: 'maxOdd',
      isCircle: true,
      hasLicenseCheck: true,
    },
    { key: 'GAME_INFO_HOW_TO_PLAY', type: 'title' },
    { key: 'HOW_TO_PLAY_P1', type: 'text' },
    { key: 'HOW_TO_PLAY_P2', type: 'text' },
    { key: 'GAME_RULES_GAME_FEATURES', type: 'title' },
    { key: 'AUTO_PLAY', type: 'title', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P1', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P2', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P3', type: 'text', hasAutoCheck: false },
    { key: 'AUTO_SPIN_P4', type: 'text', hasAutoCheck: false },
    { key: 'TURBO_MODE', type: 'title' },
    { key: 'TURBO_MODE_P1', type: 'text' },
    { key: 'CONNECTIVITY_AND_MALFUNCTION', type: 'title' },
    { key: 'MALFUNCTION', type: 'text' },
    { key: 'GAMBLE_FEATURE_TITLE', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_TEXT', type: 'text', hasGambleCheck: false },
    { key: 'GAMBLE_VALIDATIONS', type: 'title', hasGambleCheck: false },
    { key: 'GAMBLE_FEATURE_VALIDATIONS_TEXT', type: 'text', hasGambleCheck: false },
  ],
};

export const payTableStepsContentByGame = {
  225: {
    step0: {
      id: 0,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [
        {
          x: isMobile() ? 110 : 308,
          y: isMobile() ? 255 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 340,
          text: 'SYMBOL_PAYOUT_1',
        },
        {
          x: isMobile() ? 110 : 808,
          y: isMobile() ? 545 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 340,
          text: 'SYMBOL_PAYOUT_2',
        },
      ],
      y: 0,
      titleY: 45,
    },
    step1: {
      id: 1,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 1700 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: 1157,
    },
    step2: {
      isHide: false,
      id: 2,
      text: 'JACKPOT',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 2180 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() ? 1780 : 2024,
    },
  },
  226: {
    step0: {
      id: 0,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [
        {
          x: isMobile() ? 110 : 308,
          y: isMobile() ? 255 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 340,
          text: 'SYMBOL_PAYOUT_1',
        },
        {
          x: isMobile() ? 110 : 808,
          y: isMobile() ? 545 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 340,
          text: 'SYMBOL_PAYOUT_2',
        },
      ],
      y: 0,
      titleY: 45,
    },
    step1: {
      id: 1,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 2180 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: 1217,
    },
    step2: {
      isHide: false,
      id: 2,
      text: 'JACKPOT',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 2660 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() ? 2280 : 1469,
    },
  },
  227: {
    step0: {
      id: 0,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [
        {
          x: isMobile() ? 110 : 308,
          y: isMobile() ? 255 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 280,
          text: 'SYMBOL_PAYOUT_1',
        },
        {
          x: isMobile() ? 110 : 808,
          y: isMobile() ? 545 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 280,
          text: 'SYMBOL_PAYOUT_2',
        },
      ],
      y: 0,
      titleY: 45,
    },
    step1: {
      id: 1,
      isHide: false,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 2700 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: 1167,
    },
    step2: {
      id: 2,
      text: isMobile() ? 'Jackpot' : 'WINNING_LINES',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 3160 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: isMobile() ? 'WILDS_TEXT' : 'WINNING_LINES_TEXT',
        },
      ],
      y: isMobile() ? 2790 : 1469,
    },
    step3: {
      isHide: isMobile(),
      id: 3,
      text: 'JACKPOT',
      contentImage: 'payTableStep3Image',
      stepInfoText: [
        {
          x: 6480,
          y: 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() ? 3550 : 2024,
    },
  },
  329: {
    step0: {
      id: 0,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [
        {
          x: isMobile() ? 110 : 308,
          y: isMobile() ? 255 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 340,
          text: 'SYMBOL_PAYOUT_1',
        },
        {
          x: isMobile() ? 110 : 808,
          y: isMobile() ? 545 : 310,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 340,
          text: 'SYMBOL_PAYOUT_2',
        },
      ],
      y: 0,
      titleY: 45,
    },
    step1: {
      id: 1,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 2180 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: 1217,
    },
    step2: {
      isHide: false,
      id: 2,
      text: 'JACKPOT',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 2660 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() ? 2280 : 1469,
    },
  },
};
